import React from 'react';
import { Globe, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-800 text-white mt-12">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Project Info */}
          <div>
            <div className="flex items-center mb-4">
              <a 
                href="https://www.sdsu.edu/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity"
              >
                <img 
                  src="https://logos-world.net/wp-content/uploads/2022/11/SDSU-Symbol.png"
                  alt="SDSU Logo" 
                  className="h-12 w-auto object-contain mr-4"
                />
              </a>
            </div>
            <p className="text-gray-300 text-sm">
              Comprehensive data analysis and visualization of homelessness in San Diego County, 
              integrating information from key organizations including the Regional Task Force 
              on Homelessness and SANDAG.
            </p>
          </div>

          {/* Technical Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Technical Details</h3>
            <p className="text-gray-300 text-sm mt-4">
              This dashboard is built with React and Tailwind CSS for real-time data visualization 
              and interactive analytics.
            </p>
            <p className="text-gray-300 text-sm mt-2">
              <a 
                href="https://reactjs.org/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white"
              >
                React
              </a>
              {' • '}
              <a 
                href="https://tailwindcss.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white"
              >
                Tailwind CSS
              </a>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-4 border-t border-blue-700">
          <div className="flex justify-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} San Diego Homelessness Analytics. Created for BDA600.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;